import { useEffect } from "react"
import { setupSmoothScroll, smoothScrollToElement } from "@/lib/utils"
import HomeNav from "@/components/home-nav"
import HomeFooter from "@/components/home-footer"
import HeroSection from "@/components/sections/HeroSection"
import StatsSection from "@/components/sections/StatsSection"
import FeaturesSection from "@/components/sections/FeaturesSection"
import DemoSection from "@/components/sections/DemoSection"
import FAQSection from "@/components/sections/FAQSection"
import CTASection from "@/components/sections/CTASection"

export default function HomePage() {
  useEffect(() => {
    const hash = window.location.hash
    if (hash && hash.length > 1) {
      smoothScrollToElement(hash.substring(1), 64)
    }
    const cleanup = setupSmoothScroll(64)
    return cleanup
  }, [])

  return (
    <div className="min-h-screen bg-none">
      <HomeNav />
      <HeroSection />
      <StatsSection />
      <FeaturesSection />
      <DemoSection />
      <FAQSection />
      <CTASection />
      <HomeFooter />
    </div>
  )
}
